<style lang="less" scoped>
.title-div {
    font-weight: 600;
    margin: 10px 0 10px;
    font-size: 26px;
    flex-grow: 1;
    color: #000;
    height: 30px;
}

.pileItem-div {
    font-weight: 600;
    //   margin: 0 10px !important;
    font-size: 20px;
    // flex-grow: 1;
    color: #000;
    // height: 30px;
}

.el-col {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 0;

    >div:first-of-type {
        // width: 120px;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
    }

    >div:last-of-type {
        font-size: 14px;
        min-width: 160px;
        text-align: right;
        margin-left: 20px;
    }
}
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div class="title-div">{{ mainTitle }}</div>
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">充电订单编号</div>
                        <div>{{ detailForm.orderNo }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">充电桩IMEI编号</div>
                        <div>{{ detailForm.pileCode }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">充电业务归属</div>
                        <div>{{ detailForm.sourceName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">订单状态</div>
                        <div>{{ detailForm.orderStatusName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">共享设备类型</div>
                        <div>{{ '共享开关' }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">共享充电类型</div>
                        <div>{{ '预约充电/定时充电/立即充电' }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">充电用户账号类型</div>
                        <div>{{ '共享管理/共享充电/桩主' }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">用户手机号</div>
                        <div>{{ detailForm.custPhone }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">充电用户手机号</div>
                        <div>{{ }}</div>
                    </el-col>
                    <!-- 订单属性 -->
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">订单属性</div>
                        <div>{{ detailForm.orderPropertyName }}</div>
                    </el-col>
                    <!-- 启动方式 -->
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">启动方式</div>
                        <div>{{ detailForm.mobile }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">结束方式</div>
                        <div>{{ detailForm.chargeOverReason }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex align-items">
                        <div class="cust-detail-title">开始时间</div>
                        <el-date-picker v-model="detailForm.beginTime" type="datetime" size="small"
                            :disabled='!editFlag' prefix-icon="el-icon-date" value-format="yyyy-MM-dd HH:mm:ss"
                            @change='changeTime(detailForm.beginTime)' placeholder="选择日期时间">
                        </el-date-picker>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex align-items">
                        <div class="cust-detail-title">结束时间</div>
                        <el-date-picker v-model="detailForm.endTime" type="datetime" size="small" :disabled='!editFlag'
                            value-format="yyyy-MM-dd HH:mm:ss" @change='changeTime(detailForm.endTime)'
                            prefix-icon="el-icon-date" placeholder="选择日期时间">
                        </el-date-picker>
                        <!-- <el-input prefix-icon="el-icon-date" v-model="detailForm.endTime" style="width: 65%;" size="small" :disabled='!editFlag'></el-input> -->
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex align-items">
                        <div class="cust-detail-title">充电量（kw·h）</div>
                        <el-input v-model="detailForm.chargeVal" style="width: 65%;" size="small"
                            :disabled='!editFlag'></el-input>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex align-items">
                        <div class="cust-detail-title">充电时长(分钟)</div>
                        <el-input v-model="detailForm.chargeMin" style="width: 65%;" size="small" disabled></el-input>
                    </el-col>
                    <!-- <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">退款状态</div>
                        <div>{{ }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">退款金额（元）</div>
                        <div>{{ }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">退款流水号</div>
                        <div>{{ }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">退款操作人</div>
                        <div>{{ }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">退款时间</div>
                        <div>{{ }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">订单来源</div>
                        <div>{{ }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
                        <div class="cust-detail-title">备注</div>
                        <div style="color:#4182EB">{{ detailForm.remark }}</div>
                    </el-col> -->
                </el-row>
                <!-- <div class="title-div">支付信息</div>
                <el-table class="el-table" :data="payList" border max-height="200px"
                    style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
                    <el-table-column prop="actPayFee" label="电费收益（元）">
                        <template slot-scope="scope">
                            <el-input-number @change='changeFee(scope.row.actPayFee)' v-model="scope.row.actPayFee"
                                :precision="2" :min="0" :disabled='!editFlag'></el-input-number>
                        </template>
</el-table-column>
<el-table-column prop="payStatusName" label="订单状态">
</el-table-column>
<el-table-column prop="payWhen" label="用户支付时间">
</el-table-column>
<el-table-column prop="verifyWhen" label="桩主确认时间">
</el-table-column>
</el-table> -->
                <div class="title-div">充电费用明细</div>
                <el-table class="el-table" :data="pileCalcFeeStr" border max-height="500px"
                    style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
                    <el-table-column prop="startTimeStr" label="支付流水号" />
                    <el-table-column prop="startTimeStr" label="预付退款流水号" />
                    <el-table-column prop="endTimeStr" label="当前时段充电单价（元）" />
                    <el-table-column prop="endTimeStr" label="充电预付费用（元）" />
                    <el-table-column prop="endTimeStr" label="充电实付费用（元）" />
                    <el-table-column prop="endTimeStr" label="已退预付费用（元）" />
                    <el-table-column prop="endTimeStr" label="桩主收益（元）" />
                    <el-table-column prop="endTimeStr" label="支付手续费（元）" />
                    <el-table-column prop="endTimeStr" label="平台服务费（元）" />
                    <el-table-column prop="endTimeStr" label="收益到账时间" />
                </el-table>
                <p>服务费率计算规则：平台服务费0.1元/度电 ；活动桩的活动服务费根据用户实际服务费+0.1元/度电</p>
                <div class="title-div">售后退款费用明细</div>
                <el-table class="el-table" :data="pileCalcFeeStr" border max-height="500px"
                    style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
                    <el-table-column prop="endTimeStr" label="售后退款流水号" />
                    <el-table-column prop="endTimeStr" label="充电实付费用（元）" />
                    <el-table-column prop="endTimeStr" label="桩主收益（元）" />
                    <el-table-column prop="endTimeStr" label="支付手续费（元）" />
                    <el-table-column prop="endTimeStr" label="平台服务费（元）" />
                    <el-table-column prop="endTimeStr" label="已退实收费用（元）" />
                    <el-table-column prop="endTimeStr" label="已退桩主收益（元）" />
                    <el-table-column prop="endTimeStr" label="已退支付手续费（元）" />
                    <el-table-column prop="endTimeStr" label="已退平台服务费（元）" />
                    <el-table-column prop="endTimeStr" label="售后退款操作时间" />
                    <el-table-column prop="endTimeStr" label="售后退款完成时间" />
                    <el-table-column prop="endTimeStr" label="售后退款原因" />
                    <el-table-column prop="endTimeStr" label="售后退款类型" />
                </el-table>
                <el-row :gutter="20">
                    <div class="title-div">充电桩信息</div>
                    <!-- <el-col :span="24"> <span  class="pileItem-div">充电桩信息</span> </el-col> -->
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">设备编号</div>
                        <div>{{ detailForm.pileCode }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">设备名称</div>
                        <div>{{ detailForm.showName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">设备型号</div>
                        <div>{{ detailForm.showName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">厂家/厂商代码</div>
                        <div>{{ detailForm.showName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">绑定方式</div>
                        <div>{{ detailForm.currentOutTypeName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">联网方式</div>
                        <div>{{ detailForm.currentOutTypeName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">电流采集</div>
                        <div>{{ detailForm.currentOutTypeName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">电压采集</div>
                        <div>{{ detailForm.phaseTypeName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">电量采集</div>
                        <div>{{ detailForm.chargingSpeed }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">温度采集</div>
                        <div>{{ detailForm.ratedVoltage }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">保护功能</div>
                        <div>{{ detailForm.ratedCurrent }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
                        <div class="cust-detail-title">指示灯</div>
                        <div>{{ detailForm.ratedPower }}</div>
                    </el-col>
                </el-row>
                <div class="title-div">共享价格时段</div>
                <el-table class="el-table" :data="pileCalcFeeStr" border max-height="500px"
                    style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="startTimeStr" label="时间段">
                    </el-table-column>
                    <el-table-column prop="endTimeStr" label="电费（元/度）">
                    </el-table-column>
                    <el-table-column prop="priceStr" label="服务费（元/度）">
                    </el-table-column>
                    <el-table-column prop="priceStr" label="充电单价（元/度）">
                    </el-table-column>
                    <el-table-column prop="priceStr" label="状态">
                    </el-table-column>
                </el-table>
                <div class="flex-r-end margin-t-20">
                    <button class="common-empty-button" @click="back()">返 回</button>
                    <button class="common-bg-button margin-r-0" v-if="editFlag" @click="submit()">确 认</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../../../utils/utils';
import config from '../../../../config/config';
import pageConfig from './page-config';
export default {
    data() {
        var self = this;
        return {
            pageConfig,
            editFlag: false,
            pageTitle: '充电桩详情',
            tableData: [], // 表格数据
            selections: [], // 表格选项
            pagination: pageConfig.pagination,
            queryInfo: {},
            // 默认值设置
            detailForm: {},
            repairForm: {},
            activeName: 'first',
            time: [],
            pileGunNum: '',
            pileStatusEntity: {},
            url: '',
            mainTitle: '',
            dialogFormVisible: false,
            payList: [],
            pileCalcFeeStr: [],
            detailBreadCrumb: [],
        }
    },
    methods: {
        init() {
            let _ = this;
            console.log(this.$route.name);
            let name = this.$route.name;
            if (name == 'publipileUnusualDetail') {
                this.mainTitle = '共享充电异常订单'
                this.detailBreadCrumb = this.pageConfig.unusualDetailBreadCrumb
            } else if (name == 'publiPileDetail') {
                this.mainTitle = '共享充电正常订单'
                this.detailBreadCrumb = this.pageConfig.detailBreadCrumb
            }
            console.log(this.$store.state.editId);
            let status = JSON.parse(localStorage.getItem('detail')).processingStatusName
            if (localStorage.getItem('status') == 'edit' && status != '已处理') {
                this.editFlag = true;
                // this.getFormInfo();
            }
            this.detailForm = JSON.parse(localStorage.getItem('detail'))
            // _.pileCalcFeeStr = JSON.parse(_.detailForm.elecSet)
            // let str = '00:00~12:00,12:01~23:59'//电价
            // _.pileCalcFeeStr = str.split(',')
            let arr = _.detailForm.openSection.split(',');
            arr.forEach(item => {
                if (_.$U.isEmpty(item)) return
                let a = item.split('~')
                let obj = {
                    startTimeStr: a[0],
                    endTimeStr: a[1],
                    priceStr: _.detailForm.elecSet,
                }
                _.pileCalcFeeStr.push(obj)
            })
            console.log(_.pileCalcFeeStr);
            _.payList = [
                {
                    actPayFee: _.detailForm.actPayFee,
                    payStatusName: _.detailForm.payStatusName,
                    payWhen: _.detailForm.payWhen,
                    verifyWhen: _.detailForm.verifyWhen,
                }
            ]
        },
        //判断开始结束时间是否选择早于/晚于结束开始时间                
        disabledDate(time) {
            let _ = this;
            if (time < this.detailForm.beginTime) {
                _.$U.error('选择时间不能早于充电开始时间');
                this.detailForm.endTime = ''
                return false
            } else if (time > this.detailForm.endTime) {
                _.$U.error('选择时间不能晚于充电结束时间');
                this.detailForm.beginTime = ''
                return false
            } else {
                return true
            }
        },
        changeTime(time) {
            let _ = this;
            //true的话 根据选择的开始结束时间算出时间间隔,并转换为XX分钟
            if (this.disabledDate(time)) {
                if (_.$U.notEmpty(this.detailForm.beginTime) && _.$U.notEmpty(this.detailForm.endTime)) {
                    let start = new Date(this.detailForm.beginTime.replace("-", "/").replace("-", "/"));
                    let end = new Date(this.detailForm.endTime.replace("-", "/").replace("-", "/"));
                    let date3 = new Date(end).getTime() - start.getTime();

                    let days = Math.floor(date3 / (24 * 3600 * 1000))
                    let leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
                    let hours = Math.floor(leave1 / (3600 * 1000))
                    //计算相差分钟数
                    let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
                    let minutes = Math.floor(leave2 / (60 * 1000))
                    //计算相差秒数
                    let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
                    let seconds = Math.round(leave3 / 1000);
                    if (days > 0) {
                        hours = hours + 24 * days
                    } else {
                        hours = hours
                    }
                    if (hours > 0) {
                        minutes = minutes + 60 * hours
                    } else {
                        minutes = minutes
                    }
                    if (seconds > 0) {
                        minutes = minutes + 1
                    } else {
                        minutes = minutes
                    }
                    _.detailForm.chargeMin = minutes
                }
            }
        },
        //修改订单金额
        changeFee(fee) {
            let _ = this;
            _.detailForm.actPayFee = fee
        },
        //修改订单金额
        submit() {
            let _ = this;
            let obj = {
                actPayFee: _.detailForm.actPayFee,
                id: _.detailForm.id,
                beginTime: _.detailForm.beginTime,
                endTime: _.detailForm.endTime,
                chargeVal: _.detailForm.chargeVal,
                chargeTime: _.detailForm.chargeMin,
            };
            _.$H.post(_, _.$A.privatePile.updateOrder, obj).then((res) => {
                _.$U.success('修改成功！');
                _.$router.push({
                    name: pageConfig.listRouter
                })
            });
        },
        back() {
            this.$router.go(-1)
        }
    },
    mounted() {
        // this.mainTitle = this.$route.name =='unusualList'? '异常充电订单':'正常充电订单'
        this.init();
    }
}
</script>